import { PayloadAction } from '@reduxjs/toolkit';
import { PlanboardState, DemoOperationPayload } from '@reducers/v2/planboard/types';

export const setDemoOperationsAction = (state: PlanboardState, action: PayloadAction<DemoOperationPayload[]>) => {
  action.payload.forEach(({ machineId, data }) => {
    state.machineProductionOperations[machineId] = data;
  });
};
